import React, { ForwardedRef, ReactElement, RefAttributes } from 'react';

export const memo: <T>(c: T) => T = React.memo;
// eslint-disable-next-line @typescript-eslint/ban-types
export const forwardRef = <T, P = {}>(render: (props: P, ref: ForwardedRef<T>) => ReactElement | null) =>
    React.forwardRef(render) as (props: P & RefAttributes<T>) => ReactElement | null;
